import React from 'react'
import AdvancedTable from '../../Components/AdvancedTable'
import FunctionSelector from './FunctionSelector'

class AttractionSelector extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _simpleBoolView = (bool) => {
    return (
      <span className={`badge badge-${bool ? 'danger' : 'success'}`}>{bool ? 'Disabled' : 'Enabled'}</span>
    )
  }

  render () {
    const { array } = this.props
    return (
      <section className='section mt-3 mb-3'>
        <div className='title-block'>
          <h1 className='title'>Selected Attractions</h1>
        </div>
        <div className='modal-content mb-3'>
          <AdvancedTable
            colSpan={4}
            header={[
              { field: 'ID' },
              { field: 'Title' },
              { field: 'Status' },
              { field: 'Remove' }
            ]}
            body={
              array.length > 0 &&
              array.map((item, i) => ([
                { field: item.id },
                { field: item.title },
                { field: this._simpleBoolView(item.is_disabled) },
                { field: <button onClick={() => this.props.arrayDecrease(item.id)} key={i} className='btn btn-danger'><i className='fa fa-arrow-up' /></button> }
              ]))
            }
          />
        </div>
        <FunctionSelector
          {...this.props}
          options={[
            { value: '', description: '-Please Select Action-', disabled: true },
            { value: 'disable', description: 'Disable Attraction', disabled: false },
            { value: 'enable', description: 'Enable Attraction', disabled: false }
          ]}
        />
        <div className='row'>
          <div className='col-12 text-right'>
            <button className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button className='btn btn-primary' onClick={() => this.props.executeToggle(this.props.functionState)}>Apply</button>
          </div>
        </div>
      </section>

    )
  }
}

export default AttractionSelector



// WEBPACK FOOTER //
// ./src/Containers/CronReport/AttractionSelector.js